import { render, staticRenderFns } from "./Graphiql.vue?vue&type=template&id=1495cc85&scoped=true&lang=pug&"
import script from "./Graphiql.vue?vue&type=script&lang=ts&"
export * from "./Graphiql.vue?vue&type=script&lang=ts&"
import style0 from "./Graphiql.vue?vue&type=style&index=0&id=1495cc85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495cc85",
  null
  
)

export default component.exports